import { withStory, WithStoryProps } from "@storyofams/storyblok-toolkit"
import { GetStaticPaths, GetStaticProps } from "next"
import { DynamicPage } from "~components/common/DynamicPage"
import { enhancedStaticProps, sdk as sdkClient } from "~lib"
import { FooterComponent, NavigationComponent, PageItem } from "~graphql/sdk"

export interface PageProps extends WithStoryProps {
    footer: FooterComponent
    navigation: NavigationComponent
}

const Page = ({ ...props }: PageProps) => <DynamicPage {...props} />

export default withStory(Page)

export const getStaticProps: GetStaticProps = enhancedStaticProps(
    async ({ params: { slug }, sdk, defaultLocale, locale }) => {
        let story: PageItem | undefined
        let notFound = false

        try {
            const id = `${defaultLocale !== locale ? `${locale}/` : ""}${slug}`
            story = (
                await sdk.pageItem({
                    slug: id,
                    lang: defaultLocale !== locale ? locale : "default",
                })
            ).PageItem
        } catch (e) {
            notFound = true
        }

        return {
            props: {
                story,
                slug,
            },
            notFound: notFound || !story,
            revalidate: 60,
        }
    }
)

export const getStaticPaths: GetStaticPaths = async () => {
    let stories: Array<PageItem> | undefined

    try {
        stories = (await sdkClient.pageItems()).PageItems.items
    } catch (e) {}

    return {
        paths: stories
            ?.filter(({ slug }) => slug !== "home")
            ?.map(({ slug }) => ({
                params: { slug },
            })),
        fallback: "blocking",
    }
}
